<div class="row">
  <div class="col-xs-12">
<!--    <table>-->
<!--      <tr>-->
<!--        <td><b>Command:</b></td>-->
<!--        <td>{{inputForm.value.action}}</td>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <td><b>Source:</b></td>-->
<!--        <td>{{inputForm.value.sourceDevice}}</td>-->
<!--      </tr>-->
<!--      <tr>-->
<!--        <td><b>Destination:</b></td>-->
<!--        <td>{{inputForm.value.target}}-->
<!--          <span *ngIf="inputForm.value.destination != destinations.gcx_sites">-->
<!--            <ng-container [ngSwitch]="inputForm.value.action">-->
<!--              <span *ngSwitchCase="actions.a_ping">({{results["ping-results"][0]["target-ip"][0].data}})</span>-->
<!--              <span *ngSwitchCase="actions.b_trace">({{results["traceroute-results"][0]["target-ip"][0].data}})</span>-->
<!--            </ng-container>-->
<!--          </span></td>-->
<!--      </tr>-->
<!--    </table>-->
    <br><b>Results:</b>
    <pre>
      {{results}}
    </pre>
  </div>
</div>
